import { useEffect, useState } from "react";
import {
  BuildFilled,
  GlobalOutlined,
} from "@ant-design/icons";
import { BsRobot } from "react-icons/bs";
import { LuUsers } from "react-icons/lu";
import { LucideSquareFunction } from "lucide-react";
import { FaIndustry } from "react-icons/fa";
import { GrUserSettings } from "react-icons/gr";

const getUserRole = () => localStorage.getItem("role");

export const useAgentPageSideMenuItems = () => {
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    const role = getUserRole();

    const items = [
      {
        key: "1",
        icon: <BsRobot className="me-2" />,
        label: "My Agents",
      },
      {
        key: "2",
        icon: <GlobalOutlined className="me-2" />,
        label: "Public Agents",
      },
      {
        key: "4",
        icon: <BuildFilled className="me-2" />,
        label: "Organizational Agents",
      },
      {
        key: "5",
        icon: <LucideSquareFunction style={{ width: "19px" }} className="me-2" />,
        label: "Create Functions",
      },
      {
        key: "7",
        icon: <LuUsers className="me-2" />,
        label: "User Agents",
      },
    ];

    if (role === "superadmin") {
      items.push({
        key: "8",
        icon: <FaIndustry className="me-2" />,
        label: "Industry Agents",
      });
    }

    if (role === "admin") {
      items.push({
        key: "9",
        icon: <GrUserSettings className="me-2" />,
        label: "Agent Settings",
      });
    }

    setMenuItems(items);
  }, []);

  return menuItems;
};
